import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import { FunctionComponent } from "react";
import { Bar } from "react-chartjs-2";
import { MIA_ACCENT } from "./colors";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ChartWrapper = styled.div`
  height: 260px;
  position: relative;
`;

interface Props {
  labels: string[];
  signaled: number[];
  neutralized: number[];
  signaledLabel: string;
  neutralizedLabel: string;
}

const TimelineBar: FunctionComponent<Props> = ({
  labels,
  signaled,
  neutralized,
  signaledLabel,
  neutralizedLabel,
}) => {
  const theme = useTheme();

  const data = {
    labels,
    datasets: [
      {
        label: signaledLabel,
        data: signaled,
        backgroundColor: theme.palette.grey[300],
        borderRadius: 4,
      },
      {
        label: neutralizedLabel,
        data: neutralized,
        backgroundColor: MIA_ACCENT,
        borderRadius: 4,
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" as const },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <ChartWrapper>
      <Bar data={data} options={options} />
    </ChartWrapper>
  );
};

export default TimelineBar;
